import { render } from "./BudgetView.vue?vue&type=template&id=1a53f78c&scoped=true"
import script from "./BudgetView.vue?vue&type=script&lang=js"
export * from "./BudgetView.vue?vue&type=script&lang=js"

import "./BudgetView.vue?vue&type=style&index=0&id=1a53f78c&scoped=true&lang=css"

import exportComponent from "/home/walter/projects/finances-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a53f78c"]])

export default __exports__